// extracted by mini-css-extract-plugin
var _1 = "StatisticChartTab-modulechart__kjIUj";
export { _1 as "chart" }
